import { motion } from "framer-motion";
import { SEO } from "../components/common/SEO";
import { SEO_DATA } from "../data/seoData";

const SECTIONS = [
  { title: "Overview", content: "At SwitchYourVendor, we strive for complete client satisfaction. This Refund Policy outlines the circumstances under which refunds may be issued for our services." },
  { title: "Vendor Matching Services", content: "Our vendor matching and consultation services are provided free of charge. Since there is no upfront payment for vendor discovery and matching, no refund applies to these services." },
  { title: "Paid Service Plans", content: "For paid subscription plans and managed services: you may request a full refund within 7 days of purchase if no services have been rendered. Partial refunds may be considered on a case-by-case basis for services partially rendered. No refunds will be issued after 30 days from the date of purchase." },
  { title: "Third-Party Vendor Services", content: "Refunds for services provided by third-party vendors must be handled directly with the respective vendor. SwitchYourVendor will assist in facilitating refund requests but is not liable for refunds from third-party vendors." },
  { title: "How to Request a Refund", content: "To request a refund, please contact us at info@switchyourvendor.com with your service details and reason for the refund request. Our team will review your request and respond within 5 business days." },
  { title: "Processing Time", content: "Approved refunds will be processed within 7-10 business days. The refund will be credited to the original payment method used for the purchase." },
  { title: "Exceptions", content: "Refunds will not be issued for: services that have been fully rendered; customized solutions that have been implemented; cancellations after the service delivery period." },
  { title: "Contact Us", content: "For any questions about our Refund Policy, please contact us at info@switchyourvendor.com or call +91 8287428256." },
];

export default function RefundPolicyPage() {
  return (
    <div>
      <SEO 
        title={SEO_DATA.refundPolicy.title}
        description={SEO_DATA.refundPolicy.description}
        keywords={SEO_DATA.refundPolicy.keywords}
        canonical="https://switchyourvendor.com/refund-policy"
      />
      <section className="pt-20 pb-10" style={{ background: "linear-gradient(135deg, #f8fafc, #ffffff)" }}>
        <div className="max-w-3xl mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="text-red-600 font-bold text-xs tracking-[0.2em] uppercase font-body">Legal</span>
            <h1 className="font-heading text-3xl sm:text-4xl font-black mt-3 mb-3 tracking-tight">Refund Policy</h1>
            <p className="text-slate-500 text-sm font-body">Last updated: December 2025</p>
          </motion.div>
        </div>
      </section>
      <section className="py-10 bg-white">
        <div className="max-w-3xl mx-auto px-6 space-y-8">
          {SECTIONS.map((s, i) => (
            <motion.div key={s.title} initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}>
              <h2 className="font-heading text-xl font-black text-slate-900 mb-2">{i + 1}. {s.title}</h2>
              <p className="text-sm text-slate-600 leading-relaxed font-body">{s.content}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
